module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0165.jpg?v=ae51a7d4";